export const isObjectWithKeys = <T extends string | number | symbol>(
  value: unknown,
  ...keys: T[]
): value is Record<T, unknown> => {
  if (typeof value !== 'object' || !value) {
    return false;
  }
  return keys.every((key) => key in value);
};
